<script setup>
/******************************************************************************
 * PageComponent: ReadingReqCustomerHeader
 // *****************************************************************************/
import SvgIcon from "Components/SvgIcon/SvgIcon.vue";
import { useReadingStore } from "Stores/reading";
const readingStore = useReadingStore();
const channels = readingStore.config.readingReqOutputChannels;
const props = defineProps({
    customer: {
        type: Object,
        required: true,
    },
});
const currentChannel = channels.find(
    (channel) => channel.no === props.customer.readingReqChannel
);
</script>

<template>
    <div class="header">
        <svg-icon name="customer" :size="0" />
        <span class="customer-name">{{
            `${props.customer.salutation ? props.customer.salutation : ""} ${
                props.customer.name ? props.customer.name : ""
            } ${props.customer.lastName ? props.customer.lastName : ""} ${
                props.customer.nameAddon ? props.customer.nameAddon : ""
            }`
        }}</span>
        <span class="customer-no"
            >Kundennummer: <cite>{{ props.customer.customerNo }}</cite></span
        >
    </div>
    <div class="channel">
        Bislang erhalten Sie Ihre Ableseaufforderung per
        <span class="current">
            <svg-icon :name="currentChannel.icon" />
            {{ currentChannel.label }}
        </span>
    </div>
</template>

<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    margin-bottom: #{get($sizes, "base") * 0.5};
    gap: #{get($sizes, "base") * 0.5};

    @include respond-to("medium") {
        margin-bottom: #{get($sizes, "base") * 1};
    }
}

.customer-no cite {
    color: palette("brand1", "color");

    font-style: normal;
}

.current {
    padding: get($sizes, "border") 1ch;

    background-color: get($client, "outputChannelCurrentBg");
    color: get($client, "outputChannelCurrentColor");

    font-size: get($sizes, "base");
}

.channel {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    gap: #{get($sizes, "base") * 0.5};
}
</style>
